import { ListItem, ListItemText, Typography } from '@mui/material';
import ACTIONS from '@pages/lending/types/actionsEnum.type';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { List } from 'reactstrap';

interface DetailsProps {
  detailType: ACTIONS;
}

const Details = ({ detailType }: DetailsProps) => {
  const { t } = useTranslation();
  const isAccept = detailType === ACTIONS.ACCEPT;
  return (
    <List
      className={clsx(
        'max-w-80 mx-auto rounded-lg !py-2 my-3',
        isAccept ? 'bg-emerald-100' : 'bg-red-100'
      )}
    >
      <ListItem alignItems="flex-start" className="!py-0 border-b">
        <ListItemText
          primary={t('ldExpBenefitSender')}
          secondary={
            <Typography
              sx={{ display: 'inline' }}
              component="span"
              variant="body1"
              className="!font-semibold"
            >
              quien lo manda
            </Typography>
          }
        />
      </ListItem>
      <ListItem alignItems="flex-start" className="!py-0 border-b">
        <ListItemText
          primary={t('ldExpTotalAmount')}
          secondary={
            <Typography
              sx={{ display: 'inline' }}
              component="span"
              variant="body1"
              className="!font-semibold"
            >
              monto total
            </Typography>
          }
        />
      </ListItem>
      <ListItem alignItems="flex-start" className="!py-0 border-b">
        <ListItemText
          primary={t('ldExpPO')}
          secondary={
            <Typography
              sx={{ display: 'inline' }}
              component="span"
              variant="body1"
              className="!font-semibold"
            >
              PO
            </Typography>
          }
        />
      </ListItem>
      <ListItem alignItems="flex-start" className="!py-0 border-b">
        <ListItemText
          primary={t('ldExptPercent')}
          secondary={
            <Typography
              sx={{ display: 'inline' }}
              component="span"
              variant="body1"
              className="!font-semibold"
            >
              porcentaje
            </Typography>
          }
        />
      </ListItem>
      <ListItem alignItems="flex-start" className="!py-0 border-b">
        <ListItemText
          primary={t('ldExpCost')}
          secondary={
            <Typography
              sx={{ display: 'inline' }}
              component="span"
              variant="body1"
              className="!font-semibold"
            >
              costo
            </Typography>
          }
        />
      </ListItem>
      <ListItem alignItems="flex-start" className="!py-0 border-b">
        <ListItemText
          primary={t('ldExpDesAmount')}
          secondary={
            <Typography
              sx={{ display: 'inline' }}
              component="span"
              variant="body1"
              className="!font-semibold"
            >
              monto final
            </Typography>
          }
        />
      </ListItem>
    </List>
  );
};

export default Details;
